import type { AiMessageResponse, MapSnapshot, Preferences } from '@smysly/shared';

export class ApiError extends Error {
  constructor(public readonly status: number, public readonly code: string, message: string) {
    super(message);
  }
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...options.headers },
  });
  if (response.status === 204) return undefined as T;
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(response.status, data.error ?? 'REQUEST_FAILED', data.message ?? data.error ?? 'Ошибка сети');
  return data as T;
}

export const api = {
  telegramAuth: (initData: string) => request<{ user: { publicId: string } }>('/api/auth/telegram', { method: 'POST', body: JSON.stringify({ initData }) }),
  devAuth: () => request<{ user: { publicId: string } }>('/api/auth/dev', { method: 'POST', body: '{}' }),
  me: () => request<{ user: { publicId: string }; currentSession: unknown; hasMap: boolean }>('/api/me'),
  startSession: () => request<MapSnapshot>('/api/session', { method: 'POST', body: '{}' }),
  currentSession: () => request<MapSnapshot>('/api/session/current'),
  sendMessage: (sessionId: string, message: string) => request<AiMessageResponse>('/api/ai/message', { method: 'POST', body: JSON.stringify({ sessionId, message }) }),
  selectMeanings: (titles: string[]) => request<MapSnapshot>('/api/journey/select', { method: 'POST', body: JSON.stringify({ titles }) }),
  patchMeaning: (id: string, patch: Record<string, unknown>) => request<MapSnapshot>(`/api/meanings/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  popMeaning: (id: string, shellOnly = false) => request<MapSnapshot>(`/api/meanings/${id}/pop`, { method: 'POST', body: JSON.stringify({ shellOnly }) }),
  removeShell: (id: string) => request<MapSnapshot>(`/api/meanings/${id}/shell/remove`, { method: 'POST', body: '{}' }),
  mergeMeanings: (sourceId: string, targetId: string, title?: string) => request<MapSnapshot>('/api/meanings/merge', { method: 'POST', body: JSON.stringify({ sourceId, targetId, title }) }),
  splitMeaning: (id: string, titles: [string, string]) => request<MapSnapshot>(`/api/meanings/${id}/split`, { method: 'POST', body: JSON.stringify({ titles }) }),
  preferences: (patch: Partial<Preferences>) => request<MapSnapshot>('/api/preferences', { method: 'PATCH', body: JSON.stringify(patch) }),
  ghostConsent: (consent: boolean) => request<MapSnapshot>('/api/ghost/consent', { method: 'POST', body: JSON.stringify({ consent }) }),
  analytics: (event: string) => request<void>('/api/analytics', { method: 'POST', body: JSON.stringify({ event }) }).catch(() => undefined),
};
